export default __webpack_public_path__ + "static/pcViewerBackground-6942a00216e77d09c5be5e891412755a.png";